/**
 * NOS-91: Component catalog for adding elements to sections.
 * Per docs/specs/BUILDER_DESIGN_SPEC.md Section 16.
 */

export type ComponentCategory = "All" | "Text" | "Media" | "Interactive" | "Layout" | "Utility"

export interface CatalogItem {
  type: string
  label: string
  icon: string
  category: ComponentCategory
}

/** COMPONENT_CATALOG from spec Section 16 - 20 types */
export const COMPONENT_CATALOG: CatalogItem[] = [
  { type: "heading", label: "Heading", icon: "H", category: "Text" },
  { type: "subheading", label: "Subheading", icon: "h", category: "Text" },
  { type: "paragraph", label: "Paragraph", icon: "¶", category: "Text" },
  { type: "image", label: "Image", icon: "🖼", category: "Media" },
  { type: "video", label: "Video Embed", icon: "▶", category: "Media" },
  { type: "logo", label: "Logo", icon: "◎", category: "Media" },
  { type: "map", label: "Map Embed", icon: "📍", category: "Media" },
  { type: "button", label: "Button", icon: "◉", category: "Interactive" },
  { type: "link", label: "Link", icon: "🔗", category: "Interactive" },
  { type: "donation-selector", label: "Donation Amounts", icon: "$", category: "Interactive" },
  { type: "form-field", label: "Form Field", icon: "☐", category: "Interactive" },
  { type: "social-icons", label: "Social Icons", icon: "⊕", category: "Interactive" },
  { type: "card", label: "Card", icon: "▢", category: "Layout" },
  { type: "stat", label: "Stat", icon: "#", category: "Layout" },
  { type: "testimonial", label: "Testimonial", icon: "❝", category: "Layout" },
  { type: "team-member", label: "Team Member", icon: "👤", category: "Layout" },
  { type: "icon-text", label: "Icon + Text", icon: "◆", category: "Layout" },
  { type: "list-item", label: "List Item", icon: "•", category: "Layout" },
  { type: "divider", label: "Divider", icon: "—", category: "Utility" },
  { type: "spacer", label: "Spacer", icon: "↕", category: "Utility" },
]

/** Default content shapes from spec Section 16 */
export function getDefaultElementContent(type: string): Record<string, unknown> {
  switch (type) {
    case "heading":
      return { text: "New Heading" }
    case "subheading":
      return { text: "New Subheading" }
    case "paragraph":
      return { text: "Add your text here." }
    case "button":
      return { text: "Click me" }
    case "link":
      return { text: "Learn more" }
    case "image":
      return { src: "", alt: "" }
    case "stat":
      return { value: "0", label: "Label" }
    case "team-member":
      return { name: "Name", role: "Role" }
    case "testimonial":
      return { quote: "Testimonial text", author: "Author" }
    case "card":
      return { title: "Card Title", text: "Card description" }
    case "donation-selector":
      return { amounts: ["$25", "$50", "$100", "Other"] }
    case "logo":
      return { text: "Logo" }
    case "icon-text":
      return { icon: "★", text: "Feature" }
    case "list-item":
      return { text: "List item" }
    case "social-icons":
      return { links: ["Twitter", "Facebook", "Instagram"] }
    case "video":
      return { url: "" }
    case "map":
      return { address: "" }
    case "form-field":
      return { label: "Field", type: "text" }
    case "divider":
      return {}
    case "spacer":
      return { height: 32 }
    default:
      return {}
  }
}

export const COMPONENT_CATEGORIES: ComponentCategory[] = [
  "All",
  "Text",
  "Media",
  "Interactive",
  "Layout",
  "Utility",
]
